export default __webpack_public_path__ + "static/media/exclusivesiliconvalley.2d55b342.jpg";